import { render } from "./DefaultHeaderComponent.vue?vue&type=template&id=652d7956&ts=true"
import script from "./DefaultHeaderComponent.vue?vue&type=script&lang=ts"
export * from "./DefaultHeaderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__